import { render, staticRenderFns } from "./ScannerImagesButton.vue?vue&type=template&id=1f01bae8&scoped=true&"
import script from "./ScannerImagesButton.vue?vue&type=script&lang=js&"
export * from "./ScannerImagesButton.vue?vue&type=script&lang=js&"
import style0 from "./ScannerImagesButton.vue?vue&type=style&index=0&id=1f01bae8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f01bae8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f01bae8')) {
      api.createRecord('1f01bae8', component.options)
    } else {
      api.reload('1f01bae8', component.options)
    }
    module.hot.accept("./ScannerImagesButton.vue?vue&type=template&id=1f01bae8&scoped=true&", function () {
      api.rerender('1f01bae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScannerImagesButton.vue"
export default component.exports